// src/components/dialogs/ConfirmNavigation.jsx
import React from "react";
import {
    Box,
    ClickAwayListener,
    Fade,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from "@mui/material";

import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import GreenButton from "../buttons/GreenButton";

export default function ConfirmNavigationDialog({
    open,
    onClose,
    onConfirm,
    clickAway,
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Fade}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                "& .MuiPaper-root": {
                    background: "rgba(0,0,0,0.9)",
                    width: "500px",
                    height: "250px",
                    border: "2px solid rgba(50, 180, 65, 1)",
                    borderRadius: "8px",
                    padding: "20px",
                },
            }}
        >
            <ClickAwayListener onClickAway={clickAway}>
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    height="100%"
                >
                    <DialogContent
                        id="alert-dialog-description"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <PriorityHighIcon
                            sx={{ color: "green", fontSize: "75px" }}
                        />
                        <Typography color="green" fontSize="1.5rem">
                            There are unsaved Changes. Are you sure you want to
                            continue?
                        </Typography>
                    </DialogContent>

                    <DialogActions
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <GreenButton
                            onClick={onClose}
                            bgColor="red"
                            text="Cancel"
                        />
                        <GreenButton
                            onClick={onConfirm}
                            bgColor="green"
                            text="Continue"
                        />
                    </DialogActions>
                </Box>
            </ClickAwayListener>
        </Dialog>
    );
}
